// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"230":"80be805b","239":"5e82a5af","898":"ecb22fcc"}[chunkId] + ".css";
};